import React, { useEffect } from "react"
import GitHubCalendar from "github-calendar"
import "../components/git-calendar.css"

export default function GitCalendar() {
  useEffect(() => {
    console.log(
      GitHubCalendar(".calendar", "debajitdeb11", {
        responsive: true,
        tooltips: true,
        global_stats: true,
        summary_text: "Contributions by @debajitdeb11",
      })
    )
  }, [])

  return (
    <div
      className="calendar"
      style={{
        maxWidth: 600,
      }}
    ></div>
  )
}
